import ScalarIconEye_vue_vue_type_script_setup_true_lang_default from "./ScalarIconEye.vue.script.js";
//#region src/components/ScalarIconEye.vue
var ScalarIconEye_default = ScalarIconEye_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconEye_default as default };

//# sourceMappingURL=ScalarIconEye.js.map